import React from "react";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import ListItem from "./components/ListItem";
import { Col, Row, Spin } from "antd";
import styles from "./index.module.scss";
import useRequest from "utils/useRequest";
import { paperEvaluationList2 } from "service/exam";

export default function ReceivedEvaluation() {
    const [data, { loading }] = useRequest(paperEvaluationList2);

    return (
        <Spin spinning={loading}>
            <div className={styles.root}>
                <Row gutter={[20, 20]}>
                    {data?.map(item => (
                        <Col key={item.evaluationId} span={8}>
                            <ListItem key={item.evaluationId} data={item} />
                        </Col>
                    ))}
                </Row>

                {data?.length === 0 && (
                    <CustomEmpty
                        style={{ padding: "100px 0" }}
                        description="无数据"
                    />
                )}
            </div>
        </Spin>
    );
}
